import { strapiAssetBaseUrl } from './routes/assets';

export const quotationPopup = {
  expirationDay: 30
};

export const productPopup = {
  expirationDay: 30
};

export const imagePopup = {
  isEnabled: true,
  alt: 'Sub-Zero Wolf Pop Up',
  delayTimer: 1000,
  href: 'https://subzero-wolf.com.ph/news-and-events/090126',
  src: `${strapiAssetBaseUrl}/Square_Website_Pop_Up_Final_51f1fdde98.jpg`
};
